'use client';

import { IPageEntry } from '../../../contentful/types/IPage';
import { PageSections } from '../../content-sections/ui/PageSections';

interface IHomeContentSection {
	page: IPageEntry;
}

export default function HomeContentSection({ page }: IHomeContentSection) {
	return (
		<>
			<PageSections sections={page?.fields?.sections} />
		</>
	);
}
